export default "/images/vendor/flag-icons/flags/4x3/gt.svg?f804f6bc8952e961d81647f21fe7905f";